<template>
  <div>
    <div style="display:flex;align-items:center;">
      <div style="width:4px;height:18px;background-color:#519bcd;margin-right:8px"></div>
      <span style="font-size:18px;font-weight:400;color:#333;">培训公告</span>
    </div>
    <a-table :columns="columns" :dataSource="data" size="middle" :pagination="pagination" @change="tableChange" :rowClassName="classFun">
      <template slot="name" slot-scope="text, record">
        <a href="javascript:;" @click="showContent(record)">{{ text }}</a>
      </template>
    </a-table>
    <div style="display:flex;align-items:center;">
      <div style="width:4px;height:18px;background-color:#519bcd;margin-right:8px"></div>
      <span style="font-size:18px;font-weight:400;color:#333;">培训调查</span>
    </div>
    <div style="display:flex;align-items:flex-end;">
      <span style="margin-top:16px;font-size:14px;font-weight:400;color:#333">到目前共有247人需要培训，您是否需要培训？</span>
      <a-checkbox></a-checkbox>
    </div>
    <div style="display:flex;align-items:center;margin-top:24px">
      <div style="width:4px;height:18px;background-color:#519bcd;margin-right:8px"></div>
      <span style="font-size:18px;font-weight:400;color:#333;">网上培训</span>
    </div>
    <a-table :columns="pxColumns" :dataSource="pxData" size="middle" :pagination="pxPagination" @change="pxChange" :rowClassName="classFun" :scroll="{x:true,}">
      
    </a-table>

    <a-modal :title="title" v-model="visible" :footer="null" centered width="1000px">
      <div class="maxContainer">
        <div ref="content"></div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { http } from '@/utils/http'

let pxData = []
for(let i = 0; i < 1; i++) {
  pxData.push({
    key: i,
    index: i+1,
    name: '[第 36 期]高分辫场发射扫描电子显微镜',
    bixue: '[第 36 期]高分辫场发射扫描电子显微镜',
    teacher: '张莎莎',
    scTime: '2020/11/17 15:59:25',
    operation: '报名'
  })
}
export default {
  name: 'DayiHistory',
  data() {
    return {
      columns: [
        {
          title: '编号',
          dataIndex: 'index',
          align: 'center',
          width: 70
        },
        {
          title: '培训项目',
          dataIndex: 'name',
          scopedSlots: {
            customRender: 'name'
          }
        },
        {
          title: '设备名称',
          dataIndex: 'assetName',
        },
        {
          title: '开始时间',
          dataIndex: 'beginTime',
        },
        {
          title: '结束时间',
          dataIndex: 'endTime',
        },
      ],
      pxColumns: [
        {
          title: '编号',
          dataIndex: 'index',
          align: 'center',
          width: 50
        },
        {
          title: '标题',
          dataIndex: 'name',
          width: 300
        },
        {
          title: '必学',
          dataIndex: 'bixue',
          // width: 280
        },
        {
          title: '教师',
          dataIndex: 'teacher',
          width: 100
        },
        {
          title: '上传时间',
          dataIndex: 'scTime',
          width: 200,
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 100
        },
      ],
      data: [],
      pxData: pxData,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 100,
        showQuickJumper: true,
      },
      pxPagination: {
        current: 1,
        pageSize: 10,
        total: 100,
        showQuickJumper: true,
      },
      visible: false,
      title: '培训公告',
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    // 请求获取培训列表
    getList() {
      let parameter = {
        assetId: this.$route.query.id,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize
      }
      http('/asset-info-training/getTrainingList', 'POST', parameter).then(res => {
        if (res.success) {
          let list = res.data.resultList
          list.forEach((item, i) => {
            item.key = item.id
            item.index = (this.pagination.current - 1) * 10 + i + 1
          })
          this.data = list
          this.pagination.total = res.data.total
        }
      })
    },
    // 查看培训内容
    showContent(record) {
      this.title = record.name
      this.visible = true
      this.$nextTick(() => {
        this.$refs.content.innerHTML = record.training
      })
    },
    // 表格行类名方法
    classFun(record) {
      if (record.index % 2 == 0) return 'gray'
    },
    // 表格分页事件
    tableChange(pagination) {
      this.pagination.current = pagination.current
      this.getList()
    },
    pxChange(pxPagination) {
      this.pxPagination.current = pxPagination.current
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-table-pagination.ant-pagination li {
  margin-left: 14px;
}
/deep/ .gray {
  background: #F7F7F7;
}
/deep/ .ant-table-thead {
  background: #F2F2F2;
}
.maxContainer {
  max-height: 500px;
  overflow: hidden;
  overflow-y: auto;
}
</style>